"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47797],{

/***/ 47797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Benefits; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function Benefits() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: `max-w-7xl mx-auto text-left py-10 px-4`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col lg:flex-row items-center gap-10 mb-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative min-w-[300px] h-[200px] lg:min-w-[525px] lg:h-[444px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/longrangemovers/assets/images/info_1.png",
                            alt: "Benefits",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: ` font-bold text-xl lg:text-3xl mb-8`,
                                children: "What Is a Long Distance Move?"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: `text-base`,
                                children: "Long-distance moves, including cross-country, interstate, or state-to-state relocations, differ from local or intrastate moves as they require crossing state lines. Such moves necessitate special federal authorization to comply with U.S. laws and regulations, including insurance requirements. These laws aim to protect consumers throughout the moving process. It's crucial to identify and choose reputable long-distance moving companies is crucial to avoid fraudulent movers known for scams such as holding belongings hostage for extra fees. Always verify the credibility of movers to ensure a safe and secure relocation."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col lg:flex-row items-center gap-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: ` font-bold text-xl lg:text-3xl mb-8`,
                                children: "How Much Does a Long Distance Move Cost?"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: `text-base`,
                                children: "The cost of moving services varies based on the volume of items being moved, the distance of the move, and the selected move date. Full-service moving companies generally have higher rates, but prices can differ significantly across providers. Some movers calculate costs based on the size of the moving equipment needed, while others price their services based on the weight or the amount of space your belongings occupy."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative w-[300px] h-[180px] lg:min-w-[504px] lg:h-[304px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/longrangemovers/assets/images/info_2.png",
                            alt: "Benefits",
                            layout: "fill"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ })

}]);